import React from 'react'

import YouTube from 'react-youtube'

import Modal from 'src/components/modal/index'

import * as styles from './modal.module.scss'


const MovieModal = ({ isOpen, close, videoID  }) => {

    const options = {
        playerVars: {
            rel: 0,
            autoplay: 1,
            iv_load_policy: 3,
            modestbranding: 1
        }
    }

    return (
        <Modal className={styles.modal} open={isOpen}>
            <div className={styles.wrapper}>
                <button onClick={close} aria-label="close" className={styles.back}></button>
                <button onClick={close} aria-label="close" className={styles.close}>close</button>

                <div className={styles.content}>
                    <div className={styles.placer}>
                        <YouTube videoId={videoID} opts={options}></YouTube>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default MovieModal